// Filter | Sort as two pills: the chosen one filled with primary, the other
// a neutral fill.
export const segmentsRowSx = {
    display: 'flex',
    gap: 1,
    mb: 2
};

export const segmentSx = (active) => (theme) => ({
    flex: 1,
    font: 'inherit',
    fontSize: 13.5,
    fontWeight: active ? 800 : 700,
    textAlign: 'center',
    color: active ? theme.palette.primary.contrastText : theme.palette.text.secondary,
    bgcolor: active ? theme.palette.primary.main : theme.palette.background.neutral,
    border: 0,
    py: 1.125,
    borderRadius: `${theme.shape.option}px`,
    cursor: 'pointer'
});

export const sortRowSx = (active) => (theme) => ({
    minHeight: theme.sizes.touchTarget,
    borderRadius: `${theme.shape.menuItem}px`,
    ...(active && {
        bgcolor: theme.palette.primary.tint12,
        color: theme.palette.primary.softText
    })
});

export const resetLinkSx = {
    fontSize: 13,
    fontWeight: 800,
    color: 'text.secondary'
};

export const applyButtonSx = (theme) => ({
    height: theme.sizes.buttonHeightLarge,
    fontSize: 15,
    fontWeight: 800,
    borderRadius: `${theme.shape.toolbarControl}px`
});
